/**
 * Created by Administrador on 3/30/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('seats', {
                parent: 'app',
                url: '/seats?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/legend/seatModelAircraft/seatModelAircrafts.html',
                        controller: 'seatsController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['seat']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabLegend('seats')
                            }],
                            seats: ['seatModelAircraftService', '$stateParams', function (seatModelAircraftService, $stateParams) {
                                return seatModelAircraftService.getSeatModelAircraftsPage($stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
            .state('seatNew', {
                parent: 'app',
                url: '/seat/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/legend/seatModelAircraft/newEditSeatModelAircraft.html',
                        controller: 'newEditSeatController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['seat', 'category']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabLegend('seats')
                            }],
                            action: [function(){
                                return "new"
                            }],
                            seat: [function () {
                                return {
                                    active: true,
                                    category: "",
                                    hasPlug: false,
                                    name: "",
                                    url: ""
                                }
                            }],
                            categories: ['categoryService', function (categoryService) {
                                return categoryService.getCategories('seats')
                            }]
                        }
                    }
                }
            })
            .state('seatEdit', {
                parent: 'app',
                url: '/seat/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/legend/seatModelAircraft/newEditSeatModelAircraft.html',
                        controller: 'newEditSeatController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['seat', 'category']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabLegend('seats')
                            }],
                            action: [function(){
                                return "edit"
                            }],
                            seat: ['seatModelAircraftService', '$stateParams', function (seatModelAircraftService, $stateParams) {
                                return seatModelAircraftService.getSeatModelAircraft($stateParams.id);
                            }],
                            categories: ['categoryService', function (categoryService) {
                                return categoryService.getCategories('seats')
                            }]
                        }
                    }
                }
            })
            .state('seatDelete', {
                parent: 'seats',
                url: '/seat/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/flightControl/legend/seatModelAircraft/deleteSeat.html',
                        controller: 'deleteSeatController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['seat']);
                            }],
                            seat: ['seatModelAircraftService', function(seatModelAircraftService) {
                                return seatModelAircraftService.getSeatModelAircraft($stateParams.id)
                            }]
                        }
                    }).result.then(function() {
                        $state.go('seats', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
